<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["BN"][obj_ab.I > 0? "EBN": "ABN"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["BN"]["BN"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroup"
                                                              :flat="true"
                                                              :defaultExpandLevel="Infinity"
                                                              :clearable="false"
                                                              :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                              v-model="obj_ab['AGIT']"
                                                              @input="AgentGroupChange"
                                                              :disabled="obj_ab.I > 0"
                                                              ref="AGIT" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{getLanguage["BN"]["L"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="true"
                                                        :options="dd_lang"
                                                        valueConsistsOf="LEAF_PRIORITY"
                                                        :defaultExpandLevel="Infinity"
                                                        :placeholder="this.utilGetDDLanguage('BN.L')"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        v-model="obj_ab['Lang']"
                                                        :limit="1"
                                                        :limitText="count => `+${count}`"
                                                        ref="Lang">
                                            </treeselect>
                                            <span class="ErrMsg">{{ ValidationErrMsg('Lang','L') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="6" v-if="this.obj_ab.AT != 0">
                                            <label class="col-form-label-sm">{{getLanguage["BN"]["DN"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_do"
                                                        :placeholder="this.utilGetDDLanguage('BN.DN')"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        @input="DomainChange"
                                                        v-model="obj_ab['DI']" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('DI','DN') }}</span>
                                        </CCol>
                                        <CCol col="6" v-if="this.obj_ab.AT == 0">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["EXCL"]}} :</label>
                                            <treeselect :multiple="true"
                                                        :options="dd_agentgroup2"
                                                        :defaultExpandLevel="Infinity"
                                                        valueConsistsOf="LEAF_PRIORITY"
                                                        :disable-branch-nodes="false"
                                                        :clearable="true"
                                                        :placeholder="getLanguage['AG']['EXCL']"
                                                        :limit="1"
                                                        :limitText="count => `+${count}`"
                                                        v-model="excludeAGI" />
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage["BN"]["DT"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="true"
                                                        :options="dd_to"
                                                        valueConsistsOf="LEAF_PRIORITY"
                                                        :defaultExpandLevel="Infinity"
                                                        :placeholder="this.utilGetDDLanguage('BN.DT')"
                                                        v-model="obj_ab['DevType']"
                                                        :limit="1"
                                                        :limitText="count => `+${count}`"
                                                        ref="DevType" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('DevType','DT') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{getLanguage["BN"]["BP"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_po"
                                                        :placeholder="this.utilGetDDLanguage('BN.BP')"
                                                        v-model="obj_ab['P']"
                                                        @input="positionChange"
                                                        ref="P" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('P','BP') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <div style="margin-bottom:20px">
                                                <label class="col-form-label-sm">{{getLanguage["BN"]["BS"]}} :</label><br>
                                                <label class="switch">
                                                    <input type="checkbox" :checked="obj_ab['RS']" @change="v => obj_ab['RS'] = v.target.checked" />
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm" style="margin-right: 20px;">{{this.getLanguage["BN"]["S"]}} :</label><br>
                                            <label class="switch">
                                                <input type="checkbox" :checked="obj_ab['HS']" @change="v => obj_ab['HS'] = v.target.checked" />
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                        <CCol col="2" class="form-group" v-show="obj_ab['HS']">
                                            <label class="col-form-label-sm">{{this.getLanguage["GL"]["SD"]}}<span class="required" /> :</label>
                                            <date-range-picker :show-dropdowns="true"
                                                               opens="center"
                                                               :auto-apply="true"
                                                               @update="defaultDateRangePickerUpdateEvent"
                                                               v-model="dateTS"
                                                               :ranges="getDefaultDateRange()">
                                                <div slot="input" slot-scope="picker">
                                                    <div v-if="dateTS.startDate != ''">
                                                        <CInput size="sm"
                                                                :value="dateTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                @change="DateTimeChange('ASD',$event)" />
                                                    </div>
                                                    <div v-else>
                                                        <CInput size="sm"
                                                                @change="DateTimeChange('ASD',$event)" />
                                                    </div>
                                                </div>
                                            </date-range-picker>
                                        </CCol>
                                        <CCol col="2" class="form-group" v-show="obj_ab['HS']">
                                            <label class="col-form-label-sm">{{this.getLanguage["GL"]["ED"]}}<span class="required" /> :</label>
                                            <date-range-picker :show-dropdowns="true"
                                                               opens="center"
                                                               :auto-apply="true"
                                                               @update="defaultDateRangePickerUpdateEvent"
                                                               v-model="dateTS"
                                                               :ranges="getDefaultDateRange()">
                                                <div slot="input" slot-scope="picker">
                                                    <div v-if="dateTS.endDate != ''">
                                                        <CInput size="sm"
                                                                :value="dateTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                @change="DateTimeChange('AED',$event)" />
                                                    </div>
                                                    <div v-else>
                                                        <CInput size="sm"
                                                                @change="DateTimeChange('AED',$event)" />
                                                    </div>
                                                </div>
                                            </date-range-picker>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage["BN"]["RURL"]}} :</label>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <CTabs variant='tabs' id="RURLTabs">
                                                <CTab :title="getLanguage['CTAB']['IP']" :active="rurlType() <= 1 ? true: false">
                                                    <CCol col="12">
                                                        <CRow>
                                                            <CCol col="6">
                                                                <label class="col-form-label-sm">{{this.getLanguage["SEO"]["PT"]}} :</label>
                                                                <treeselect :multiple="false"
                                                                            :options="dd_pt"
                                                                            :placeholder="this.utilGetDDLanguage('SEO.PT')"
                                                                            v-model="obj_ab['PT']"
                                                                            @input="PageTypeChange"
                                                                            :disabled="obj_ab['AT'] == 0" />

                                                            </CCol>
                                                            <!-- System page -->
                                                            <CCol col="6" v-if="obj_ab['PT'] == 0">
                                                                <label class="col-form-label-sm">{{this.getLanguage["SEO"]["PGT"]}} :</label>
                                                                <treeselect :multiple="false"
                                                                            :options="dd_spt"
                                                                            :placeholder="this.utilGetDDLanguage('SEO.PT')"
                                                                            v-model="obj_ab['PGT']"
                                                                            @input="ClearDD" />
                                                            </CCol>
                                                            <!-- Promotion Campaign/Title -->
                                                            <CCol col="6" v-if="obj_ab['PT'] == 1">
                                                                <label class="col-form-label-sm">{{getLanguage["MEM"]["CKMAP"]}} :</label>
                                                                <treeselect :multiple="false"
                                                                            :options="dd_promocode"
                                                                            :placeholder="this.utilGetDDLanguage('MEM.CKMAP')"
                                                                            v-model="obj_ab['PGT']" />
                                                            </CCol>
                                                            <!-- Static Page -->
                                                            <CCol col="6" v-if="obj_ab['PT'] == 2">
                                                                <label class="col-form-label-sm">{{this.getLanguage["SEO"]["PGT"]}} :</label>
                                                                <treeselect :multiple="false"
                                                                            :options="dd_stapt"
                                                                            :placeholder="this.utilGetDDLanguage('SEO.PGT')"
                                                                            v-model="obj_ab['PGT']" />
                                                            </CCol>

                                                            <CCol col="6" v-if="obj_ab['PGT'] == 103">
                                                                <label class="col-form-label-sm">{{this.getLanguage["SEO"]["PRVD"]}} :</label>
                                                                <treeselect v-if="obj_ab['PGT'] == 103"
                                                                            :multiple="false"
                                                                            :load-options="loadProviderOptions"
                                                                            :options="dd_gp"
                                                                            :placeholder="this.getLanguage['SEO']['PRVD']"
                                                                            v-model="obj_ab['GPRVD']" />
                                                                <span class="ErrMsg">{{ ValidationErrMsg('GPRVD','PRVD') }}</span>
                                                            </CCol>
                                                        </CRow>
                                                    </CCol>
                                                </CTab>
                                                <CTab :title="getLanguage['CTAB']['DU']" :active="rurlType() > 1 ? true: false">
                                                    <CCol col="12">
                                                        <label class="col-form-label-sm">{{getLanguage["BN"]["RURL"]}} :</label>
                                                        <CInput size="sm" :value="obj_ab.RURL" @change="v => obj_ab.RURL = v" :disabled="obj_ab['AT'] == 0" />
                                                    </CCol>
                                                </CTab>
                                            </CTabs>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getLanguage["BN"]["I"]}}<span class="required" /> :</label>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <CTabs variant='tabs' id="imageURLTab">
                                                <CTab :title="getLanguage['CTAB']['UI']" :active="obj_ab.IUT === false ? true: false">
                                                    <img v-if="obj_ab['I'] > 0"
                                                         width="auto"
                                                         height="150"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_ab['IU'])" />
                                                    <div class="custom-file">
                                                        <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onFileSelected" required>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-if="selectedFile === null">{{ getLanguage['CTAB']['CAI'] }}.</label>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedFile.name}}</label>
                                                        <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                    </div>
                                                    <label v-if="recdImgSize == 'banner'" class="col-form-label-sm">
                                                        {{getLanguage["ACO"]["DT"]}} - {{getLanguage["RIZ"]["IZ"]}} : 1920 x 500<br />
                                                        {{getLanguage["ACO"]["MB"]}} - {{getLanguage["RIZ"]["IZ"]}} : 1200 x 600
                                                    </label>
                                                    <label v-else-if="recdImgSize == 'gamefeature'" class="col-form-label-sm">
                                                        {{getLanguage["GF"]["GF"]}} - {{getLanguage["RIZ"]["IZ"]}} : 500 x 500
                                                    </label>
                                                    <label v-else-if="recdImgSize == 'sidebanner'" class="col-form-label-sm">
                                                        {{getLanguage["SB"]["SB"]}} - {{getLanguage["RIZ"]["IZ"]}} : 960 x 480
                                                    </label>
                                                </CTab>
                                                <CTab :title="getLanguage['CTAB']['U']" :active="obj_ab.IUT === true ? true: false">
                                                    <img v-if="obj_ab['I'] > 0"
                                                         width="auto"
                                                         height="150"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_ab['IU'])" />
                                                    <label class="sr-only" for="inlineFormInputGroupUsername">{{getLanguage["CTAB"]["U"]}}</label>
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{{ getLanguage['CTAB']['U'] }}</div>
                                                        </div>
                                                        <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['IU']" v-model="obj_ab.IU">
                                                    </div>
                                                    <label v-if="recdImgSize == 'banner'" class="col-form-label-sm">
                                                        {{getLanguage["ACO"]["DT"]}} - {{getLanguage["RIZ"]["IZ"]}} : 1920 x 500<br />
                                                        {{getLanguage["ACO"]["MB"]}} - {{getLanguage["RIZ"]["IZ"]}} : 1200 x 600
                                                    </label>
                                                    <label v-else-if="recdImgSize == 'gamefeature'" class="col-form-label-sm">
                                                        {{getLanguage["GF"]["GF"]}} - {{getLanguage["RIZ"]["IZ"]}} : 500 x 500
                                                    </label>
                                                    <label v-else-if="recdImgSize == 'sidebanner'" class="col-form-label-sm">
                                                        {{getLanguage["SB"]["SB"]}} - {{getLanguage["RIZ"]["IZ"]}} : 960 x 480
                                                    </label>
                                                </CTab>
                                            </CTabs>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["BN"]["BAT"]}} :</label>
                                            <span class="WCMsg" v-if="this.obj_ab.ALT != null">{{ this.obj_ab.ALT.length }} / 125 </span>
                                            <span class="WCMsg" v-else> 0 / 125 </span>
                                            <CInput maxlength="100" size="sm"
                                                    :value="obj_ab.ALT"
                                                    @change="v => obj_ab.ALT = v" />
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveBanner()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_fullPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd1">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <img :src="previewUrl" class="img-fluid" v-if="previewUrl">
                                    <p v-else>{{this.getLanguage['GL']['NR']}}</p>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class="pageHeader position-relative">
                        <h2 id="titleHeight">{{getLanguage["BN"]["B"]}}</h2>
                        <CButton size="sm"
                                 color="outline-info"
                                 @click="addBanner()"
                                 v-if="checkModuleAccess2(constAccessType.add)"
                                 data-toggle="notificationAddmodal"
                                 data-target="#myModal">
                            <span class="plusIcon cil-plus"></span>
                            {{getLanguage["BTN"]["AN"]}}
                        </CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class="searchBox">
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AN"]["BN"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class="searchCol">
                                <span class="searchLabel">{{getLanguage["BN"]["BS"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="BannerStatus"
                                            :placeholder="this.utilGetDDLanguage('BN.BS')"
                                            v-model="str_FV[5].FV" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[3].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[3].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[3].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[3].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[3].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[3].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class="searchCol">
                                <span class="searchLabel">{{getLanguage["BN"]["DN"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_dofs"
                                            :placeholder="this.utilGetDDLanguage('BN.DN')"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            v-model="str_FV[1].FV" />
                            </div>
                            <div class="searchCol">
                                <span class="searchLabel">{{getLanguage["BN"]["DT"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_to"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('BN.DN')"
                                            v-model="str_FV[2].FV"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>



                            <div class="searchCol">
                                <span class="searchLabel">{{getLanguage["BN"]["L"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_langfs"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('BN.L')"
                                            v-model="str_FV[4].FV"
                                            :limit="1"
                                            :limitText="count => `+${count}`"></treeselect>
                            </div>
                        </div>
                        <div class="searchBtnCol">
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class="searchBtn" size="sm" block color="success" @click="newSearch()">
                                <span class="searchIcon cil-search"></span>
                                <span>{{getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class="table-wrapper">
                <header class="table-header">
                    <strong>{{getLanguage["BN"]["BL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class="custom-table afb-blue">
                        <thead>
                            <tr>
                                <th rowspan="2">{{getLanguage["GL"]["NO"]}}</th>
                                <th rowspan="2" v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th rowspan="2">{{getLanguage["BN"]["BS"]}}<i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                                <th rowspan="2">{{getLanguage["CU"]["DN"]}}<i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i></th>
                                <th rowspan="2">{{getLanguage["BN"]["RURL"]}}</th>
                                <th rowspan="2">{{getLanguage["BN"]["DT"]}}<i @click="setSortTable('DT')" :class="setSortLogo('DT')" class="sortlogo"></i></th>
                                <th rowspan="2">{{getLanguage["BN"]["I"]}}</th>
                                <th rowspan="2">{{getLanguage["BN"]["BP"]}}<i @click="setSortTable('P')" :class="setSortLogo('P')" class="sortlogo"></i></th>
                                <th rowspan="2">{{getLanguage["BN"]["L"]}}</th>
                                <th rowspan="2">{{getLanguage["BN"]["C"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);border-top-right-radius:5px;">{{getLanguage["BN"]["S"]}}</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" style="border-left: 1.5px solid rgb(157, 157, 171);">{{getLanguage["BN"]["F"]}}</th>
                                <th id="nestedTableR2" style="border-left: 1.5px solid rgb(157, 157, 171); border-bottom-right-radius: 5px;">{{getLanguage["BN"]["T"]}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class="custom-table afb-blue">
                        <thead>
                            <tr>
                                <th rowspan="2">{{getLanguage["GL"]["NO"]}}</th>
                                <th rowspan="2" v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th rowspan="2">{{getLanguage["BN"]["BS"]}}<i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                                <th rowspan="2">{{getLanguage["CU"]["DN"]}}<i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i></th>
                                <th rowspan="2">{{getLanguage["BN"]["RURL"]}}</th>
                                <th rowspan="2">{{getLanguage["BN"]["DT"]}}<i @click="setSortTable('DT')" :class="setSortLogo('DT')" class="sortlogo"></i></th>
                                <th rowspan="2">{{getLanguage["BN"]["I"]}}</th>
                                <th rowspan="2">{{getLanguage["BN"]["BP"]}}<i @click="setSortTable('P')" :class="setSortLogo('P')" class="sortlogo"></i></th>
                                <th rowspan="2">{{getLanguage["BN"]["L"]}}</th>
                                <th rowspan="2">{{getLanguage["BN"]["C"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);border-top-right-radius:5px;">{{getLanguage["BN"]["S"]}}</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" style="border-left: 1.5px solid rgb(157, 157, 171);">{{getLanguage["BN"]["F"]}}</th>
                                <th id="nestedTableR2" style="border-left: 1.5px solid rgb(157, 157, 171); border-bottom-right-radius: 5px;">{{getLanguage["BN"]["T"]}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_bl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_bl">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                <span id="actionBtnCol">
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="cil-trash" @click="removeBanner(data)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-else-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)">
                                        <i class="cil-trash"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="cil-color-border" @click="editBanner(data.I)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-else-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)">
                                        <i class="cil-color-border"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td>
                                <span :style="`color:${data.RS == '2' ? 'green':'red' }`">{{ renderStatus(data.RS)}}</span>
                            </td>
                            <td>
                                <span v-if="data.DI != 0">{{ data.DN }}</span>
                                <span v-else>-</span>
                            </td>
                            <!--<td><a :href="data.RURL" target="_blank">{{ getRURL(setUrl(data.DN,data.RURL,data.PT,data.PGT)) }}</a></td>-->
                            <td>
                                <span v-if="data.DI != 0 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" v-html="formatURL(data.DN,data.RURL,data.PT,data.PGT)"></span>
                                <span v-if="data.DI != 0 && (isSENS == 1 && data.AGI != curAGI)">{{ data.RURL }}</span>
                            </td>
                            <td><span class="grid-line" v-for="dt in data.DT.split(',')">{{ DeviceTypeDisplay(dt) }}</span></td>
                            <td>
                                <a href="javascript:void(0)" style="color:blue" @click="setPreview(data.IU)" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                    <u>{{getLanguage["GL"]["P"]}}</u>
                                </a>
                                <a href="javascript:void(0)" style="color:blue" v-if="(isSENS == 1 && data.AGI != curAGI)">
                                    <u>{{getLanguage["GL"]["P"]}}</u>
                                </a>
                            </td>
                            <td>{{ renderPosition(data.P) }}</td>
                            <td><span class="grid-line" v-for="lang in data.Languages">{{ lang }}</span></td>
                            <td>{{ data.CB }}</td>
                            <td v-if="data.HS == false">{{getLanguage["BN"]["IN"]}}</td>
                            <td v-else>{{ formatDateTime(data.STS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td v-if="data.HS == false">{{getLanguage["BN"]["IN"]}}</td>
                            <td v-else>{{ formatDateTime(data.ETS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from "vue2-daterange-picker";
    import Treeselect from "@riophae/vue-treeselect";
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import moment from "moment";
    import "@riophae/vue-treeselect/dist/vue-treeselect.css";
    import { mapGetters, mapActions } from "vuex";
    import Loading from "vue-loading-overlay";
    import genericHelper from "@/modules/GenericHelper.js";
    import { parse } from "semver";
    import { required, requiredIf } from "vuelidate/lib/validators";
    import { constAccessType, consBannerPosition, consBannerType, constStatus, consGameFeaturePosition, loadingFullScreen } from '@/modules/Constant.js';
    import Axios from "axios";
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },

        data() {
            return {
                selectedFile: null,
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_fullPreview: false,
                bool_showSearchBar: true,
                newImg: false,
                str_FV: [
                    { F: "AGI" },
                    { F: "DI" },
                    { F: "DT_csv", FA: true },
                    {
                        F: "STS", FV: {
                            startDate: "",
                            endDate: ""
                        }
                    },
                    { F: "L_csv", FA: true },
                    { F: "RS" },
                ], //Filter Value
                dateTS: {
                    startDate: this.getTodayDate(),
                    endDate: this.getTodayEndDate()
                },
                obj_ab: {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    DN: null,
                    BT: null,
                    DI: null,
                    DevType: null,
                    DT: null,
                    P: null,
                    MT: null,
                    IU: "",
                    STS: 0,
                    ETS: 0,
                    GPRVD: null,
                    AGI: 0,
                    L: null,
                    AGIT: null,
                    HS: false,
                    bannerImage: null,
                    Lang: null,
                    RURL: null,
                    PT: null,
                    PGTS: null,
                    PGT: null,
                    IUT: false,
                    AT: 3,
                    SBEAGI: null,  //SysBanner exclude AGI
                    ALT: null
                },
                arry_DT: [],
                int_TP: 1,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_RC: 100,
                int_Total: 0,
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                int_lblPage: 1, //Hold the label value, default is 1
                str_imgURL: "",
                arry_bl: [],
                currentindex: -1,
                constAccessType: constAccessType,
                dd_pt: [{ id: '0', label: 'System Page' }, { id: '1', label: 'Promotion Page' }, { id: '2', label: 'Static Page' }], // page type
                dd_spt: [], //System Page Type
                dd_stapt: [{ id: '0', label: 'Contact Us' }, { id: '1', label: 'About Us' }, { id: '2', label: 'FAQ' }, { id: '3', label: 'How To Register' }, { id: '4', label: 'Terms Of Use' }], //Static Page Type
                dd_promocode: [],
                dd_do: [], // Domain Option
                dd_lang: [], //language option
                dd_po: [],
                dd_to: [],
                BannerStatus: [],
                dd_agentgroup: [],
                dd_agentgroup2: [],
                dd_agentgroupfs: [],
                dd_dofs: [],
                dd_langfs: [], //language option
                dd_gp: null,
                domainUrl: null,
                previewUrl: null,
                pageUrlAllow: false,
                recdImgSize: 'banner',
                excludeId: ['0', '100', '101', '102', '103', '104'],
                excludeAGI: [],
                brand: ''
            };
        },

        validations: {
            obj_ab: {
                AGIT: { required },
                DI: {
                    required: requiredIf(function (vm) {
                        this.obj_ab.AT != 0
                    }),
                },
                DevType: { required },
                P: { required },
                Lang: { required },
                GPRVD: {
                    required: requiredIf(function (vm) {
                        return vm.PT == 0 && vm.PGTS == 103;
                    }),
                }
            }
        },
        computed: {
            ...mapGetters("Language", ["getLanguage"]),
            ...mapGetters('UserInfo', ['checkModuleAccess']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),

        },
        created() {
            this.$parent.showSubMenu = 'CMS';
            this.$parent.showActiveMenu = 'CMS.BA';
            if (this.$route.path == '/WEBS/BA') {
                this.$parent.showSubMenu = 'WEBS';
                this.$parent.showSubSubMenu = 'CMS1';
                this.$parent.showActiveMenu = 'WEBS.BA';
            }
            this.getBannerStatus();
            this.getBannerType();
            this.getBannerList();
            this.getLangauge();
            this.getBannerPosition();
            this.getAgentGroup();
            this.getPageType();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            bool_fullLoading() {

            },
            getLanguage() {
                this.getBannerList();
            },
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[3].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[3].FV.endDate = "";
                    }
                }
                if (type == "ASD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.dateTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.dateTS.startDate = "";
                    }
                }
                if (type == "AED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.dateTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.dateTS.endDate = "";
                    }
                }
            },
            generateURL: function () {

                var lbl2 = "";
                var lbl3 = "";
                var lbl4 = "";
                var result = null;
                if (this.obj_ab['PT'] != null) {// if page type is selected
                    if (this.obj_ab['PGT'] == null) {//check if page title is selected
                        return 0;
                    }
                    if (result == null) {
                        result = "";
                    }
                    switch (parseInt(this.obj_ab['PT'])) {

                        case 0: //system pages
                            if (this.obj_ab['PGT'] != null) {

                                if (parseInt(this.obj_ab['PGT']) == 102 || parseInt(this.obj_ab['PGT']) == 100 || parseInt(this.obj_ab['PGT']) == 104) {
                                    for (var pt of this.dd_spt) {

                                        if (pt.id == this.obj_ab['PGT']) {
                                            lbl2 = pt.label2
                                            lbl3 = pt.label3
                                        }
                                    }
                                    result += lbl2 + "/" + lbl3;
                                }
                                else if (parseInt(this.obj_ab['PGT']) == 103) {
                                    for (var pt of this.dd_spt) {
                                        if (pt.id == '103') {
                                            lbl2 = pt.label2
                                            lbl3 = pt.label3
                                            lbl4 = pt.label4
                                        }
                                    }

                                    var category = "";
                                    var provider = "";
                                    if (this.dd_gp != null && this.obj_ab.GPRVD != 0) {
                                        for (var prvd of this.dd_gp) {
                                            if (prvd.id == this.obj_ab.GPRVD) {
                                                provider = prvd.extra;
                                                category = prvd.extraCat;
                                            }
                                        }
                                    }

                                    result += this.generateGP(category) + '/' + this.generateGP(provider);
                                }
                                else {
                                    for (var pt of this.dd_spt) {
                                        if (pt.id == this.obj_ab['PGT']) {
                                            lbl2 = pt.label
                                        }
                                    }
                                    result += this.generateGP(lbl2);
                                }

                            }
                            break;
                        case 1: //promotion pages
                            if (this.obj_ab['PGT'] != null) {
                                result += "promotiondetails/";
                                for (var i = 0; i < this.dd_promocode.length; i++) {
                                    if (this.obj_ab['PGT'] == this.dd_promocode[i].id) {
                                        result += this.generatePageUrl(this.dd_promocode[i].label);
                                        break;
                                    }
                                }
                            }
                            break;
                        case 2: //static pages
                            for (var pt of this.dd_stapt) {
                                if (parseInt(pt.id) == this.obj_ab['PGT']) {
                                    result += this.generatePageUrl(pt.label);
                                }
                            }
                            break;
                    }
                }
                else { //if pt is not selected, no redirect
                    // do nothing
                }
                //if (result)
                //    return 'https://' + this.obj_ab.DN + '/' + result;
                //return 'https://' + this.obj_ab.DN;

                return result;
            },
            getRURLTabIndex() {
                var result = 0;
                try {
                    var x = document.querySelector('#RURLTabs .nav.nav-tabs li a.active').innerText;
                    if (x == this.getLanguage['CTAB']['IP']) {
                        result = 1;
                        return result;
                    }
                    else if (x === undefined) {
                        return result;
                    }
                    else {
                        result = 2;
                        return result;
                    }
                }
                catch (ex) {
                    console.log(ex);
                }
                return result;
            },
            getIURLTabIndex() {
                var result = 0;
                try {
                    var x = document.querySelector('#imageURLTab .nav.nav-tabs li a.active').innerText;
                    if (x == this.getLanguage['CTAB']['UI']) {
                        result = 1;
                        return result;
                    }
                    else if (x === undefined) {
                        return result;
                    }
                    else {
                        result = 2;
                        return result;
                    }
                }
                catch (ex) {
                    console.log(ex);
                }
                return result;
            },
            getRURL(val) {
                var result = "No Redirect";
                if (val != null) {
                    result = this.substrContent(val, 30);
                }
                return result;
            },
            formatURL(domainName, URL, PT, PGT) {
                if (URL && URL.trim().startsWith("http") && URL.trim().startsWith("https"))
                    return '<a href="' + URL + '" target="_blank">' + this.substrContent(URL, 30) + '</a>';
                var result = '';
                var new_url = URL;
                if (PT != null && PGT != null) {
                    new_url = 'https://';
                    if (domainName != null) {
                        new_url += domainName + '/' + URL;
                        new_url = this.validateURL(new_url);
                    }
                }
                if (new_url) {
                    result = '<a href="' + new_url + '" target="_blank">' + this.substrContent(new_url, 30) + '</a>';
                }
                return result;
            },
            rurlType() {
                var result = 0;
                if (this.obj_ab.AT == 0) {
                    result = 0;
                }
                else {
                    if (this.obj_ab.PT != null) {
                        result = 0;
                    }
                    else {
                        result = 2;
                    }
                }
                return result;
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('BA', 'CMS', type);
            },
            ClearDD(value) { //here clear option and select
                this.dd_gp = null;
                this.obj_ab.GPRVD = null;
            },
            loadProviderOptions({ action, callback, instanceId }) {
                var that = this;
                if (!this.obj_ab.AGIT || !this.obj_ab.PGT) {
                    callback(this.getLanguage['MEM']['PSAA']);
                }
                else {

                    var agi = this.obj_ab.AGIT.split("-")[1];

                    this.getDataApi(`/api/dd/gameP/${agi}/0`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_gp = d.dropdownlist;
                                for (var i = 0; i < that.dd_gp.length; i++) {
                                    that.dd_gp[i].label = that.renderProviderName(that.dd_gp[i].label2);
                                }
                            }
                            else {
                                that.dd_gp = null;
                            }

                            callback();
                        });
                }
            },
            PageTypeChange(value) {
                this.obj_ab['PGTS'] = null;
                this.obj_ab['RS'] = true;
                this.dd_gp = [];
                this.obj_ab['PGT'] = null;
                this.obj_ab['RURL'] = null;
                this.pageUrlAllow = value != 99;
            },
            getPageType() {
                var that = this;
                this.getDataApi(`/api/dd/gameCat`,
                    function (d, s) {
                        if (s) {
                            that.dd_spt = d.dropdownlist;
                            that.dd_spt.push({ id: '0', label: 'Home' })
                            that.dd_spt.push({ id: '100', label: 'Promotion', label2: 'promotion-list', label3: '' })
                            //that.dd_spt.push({id:'101',label:'UserProfile',label2:'user',label3:'profile'})
                            that.dd_spt.push({ id: '102', label: 'Top5Game', label2: 'top-5-games', label3: '' })
                            that.dd_spt.push({ id: '103', label: 'Game Lobby', label2: 'game', label3: 'globby', label4: 'hall' })
                            that.dd_spt.push({ id: '104', label: 'Tournament', label2: 'tournament-list', label3: '' })

                        }
                    });
            },
            ConvertPageType(value) {
                var text = '';
                for (var i = 0; i < this.dd_pt.length; i++) {
                    if (this.dd_pt[i].id == value) {
                        text = this.dd_pt[i].label;
                    }
                }

                return text;
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroup2 = d.dropdownlist;

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (this.getUserInfo.AT == 0 && agi[0] == "0") {
                    item.isDisabled = false;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            AgentGroupChangefs(value) {
                var that = this;
                if (value) {
                    var agi = 0;
                    if (value != "")
                        agi = value.split("-")[1];
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                            }
                        });
                    //this.getDataApi(`/api/dd/lang/` + agi, function (d, s) {
                    //    if (s) {
                    //        that.dd_langfs = that.appendSelectAllOption(d.dropdownlist);
                    //    }
                    //});
                    that.str_FV[0].FV = agi;
                }
                else {
                    that.dd_dofs = [];
                    that.str_FV[0].FV = null;
                }
                //that.dd_langfs = [];
                that.str_FV[1].FV = null;
                //that.str_FV[4].FV = [];
            },
            DomainChange(value) {
                var that = this;
                if (value && value > 0) {
                    this.getDataApi(`/api/dd/dlang/` + value, function (d, s) {
                        if (s) {
                            that.dd_lang = that.appendSelectAllOption(d.dropdownlist);
                        }
                    });
                }
                else {
                    //var that = this;
                    //if (that.obj_ab.AGIT != '') {
                    //    var agi = that.obj_ab.AGIT.split("-")[1];
                    //    this.getDataApi(`/api/dd/lang/` + agi, function (d, s) {
                    //        if (s) {
                    //            that.dd_lang = that.appendSelectAllOption(d.dropdownlist);
                    //        }
                    //    });
                    //} else
                    that.dd_lang = [];
                }
                if (that.obj_ab.I == 0)
                    that.obj_ab.Lang = [];
            },
            //DomainChangefs(value) {
            //    var that = this;
            //    if (value && value>0) {
            //        this.getDataApi(`/api/dd/dlang/` + value, function (d, s) {
            //            if (s) {
            //                that.dd_langfs = that.appendSelectAllOption(d.dropdownlist);
            //            }
            //        });
            //    }
            //    else {
            //        //if (that.str_FV[0].FV > 0)
            //        //    this.getDataApi(`/api/dd/lang/` + that.str_FV[0].FV, function (d, s) {
            //        //        if (s) {
            //        //            that.dd_langfs = that.appendSelectAllOption(d.dropdownlist);
            //        //        }
            //        //    });
            //        //else
            //            that.dd_langfs = [];
            //    }
            //    that.str_FV[4].FV = [];
            //},
            positionChange(value) {
                if (parseInt(value) > 10 && parseInt(value) <= 25) {
                    this.recdImgSize = 'sidebanner';
                }
                else if (parseInt(value) > 25 && parseInt(value) <= 30) {
                    this.recdImgSize = 'gamefeature';
                }
                else {
                    this.recdImgSize = 'banner';
                }

                var p = this.renderPosition(value);
                this.obj_ab.ALT = this.brand + " Banner " + p;
            },
            AgentGroupChange(value) {
                //    if (value) {
                if (this.obj_ab['I'] == 0) {
                    this.obj_ab['DI'] = null;
                    this.obj_ab['Lang'] = null;
                    this.dd_lang = [];
                }
                var that = this;
                var agi = 0;

                if (value != "") {
                    agi = value.split("-")[1];
                    this.obj_ab.AT = value.split("-")[0];
                }
                if (this.obj_ab['AT'] == 0) {
                    this.obj_ab['PT'] = '0';
                    //this.obj_ab['PGT'] = '103';
                    this.rurlType();
                    //this.dd_po = consGameFeaturePosition;
                    this.dd_po = [{ id: '1', label: this.getLanguage['BN']['P'] + " 1" }, { id: '2', label: this.getLanguage['BN']['P'] + " 2" },
                    { id: '3', label: this.getLanguage['BN']['P'] + " 3" }, { id: ' 4', label: this.getLanguage['BN']['P'] + " 4" },
                    { id: '5', label: this.getLanguage['BN']['P'] + " 5" }, { id: '26', label: this.getLanguage['BN']['GFP'] + " 1" },
                    { id: '27', label: this.getLanguage['BN']['GFP'] + " 2" }, { id: '28', label: this.getLanguage['BN']['GFP'] + " 3" },
                    { id: '29', label: this.getLanguage['BN']['GFP'] + " 4" }];
                    this.getDataApi(`/api/dd/lang/0`, function (d, s) {
                        if (s) {
                            that.dd_lang = that.appendSelectAllOption(d.dropdownlist);
                        }
                    });
                }
                else {
                    //this.dd_po = consBannerPosition;
                    this.dd_po = [{ id: '1', label: this.getLanguage['BN']['P'] + " 1" }, { id: '2', label: this.getLanguage['BN']['P'] + " 2" },
                    { id: '3', label: this.getLanguage['BN']['P'] + " 3" }, { id: '4', label: this.getLanguage['BN']['P'] + " 4" },
                    { id: '5', label: this.getLanguage['BN']['P'] + " 5" }, { id: '6', label: this.getLanguage['BN']['P'] + " 6" },
                    { id: '7', label: this.getLanguage['BN']['P'] + " 7" }, { id: '8', label: this.getLanguage['BN']['P'] + " 8" },
                    { id: '9', label: this.getLanguage['BN']['P'] + " 9" }, { id: '10', label: this.getLanguage['BN']['P'] + " 10" },
                    { id: '11', label: this.getLanguage['BN']['P'] + " 11" }, { id: '12', label: this.getLanguage['BN']['P'] + " 12" },
                    { id: '13', label: this.getLanguage['BN']['P'] + " 13" }, { id: '14', label: this.getLanguage['BN']['P'] + " 14" },
                    { id: '15', label: this.getLanguage['BN']['P'] + " 15" }, { id: '16', label: this.getLanguage['BN']['P'] + " 16" },
                    { id: '17', label: this.getLanguage['BN']['P'] + " 17" }, { id: '18', label: this.getLanguage['BN']['P'] + " 18" },
                    { id: '19', label: this.getLanguage['BN']['P'] + " 19" }, { id: '20', label: this.getLanguage['BN']['P'] + " 20" },
                    { id: '21', label: this.getLanguage['BN']['P'] + " 21" }, { id: '22', label: this.getLanguage['BN']['P'] + " 22" },
                    { id: '23', label: this.getLanguage['BN']['P'] + " 23" }, { id: '24', label: this.getLanguage['BN']['P'] + " 24" },
                    { id: '25', label: this.getLanguage['BN']['P'] + " 25" }, { id: '26', label: this.getLanguage['BN']['GFP'] + " 1" },
                    { id: '27', label: this.getLanguage['BN']['GFP'] + " 2" }, { id: '28', label: this.getLanguage['BN']['GFP'] + " 3" },
                    { id: '29', label: this.getLanguage['BN']['GFP'] + " 4" }, { id: '30', label: this.getLanguage['BN']['GFP'] + " 5" }];
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_do = d.dropdownlist
                            }
                        });

                }

                //promo dropdown
                var agi = 0;
                var that = this;
                if (value != "") {
                    agi = value.split("-")[1];
                }

                this.getDataApi(`/api/dd/promot/${agi}/2`,
                    function (d, s) {
                        if (s) {
                            that.dd_promocode = d.dropdownlist;

                            if (that.obj_ab.PI != null) {
                                var bool_isExists = false;

                                for (var i = 0; i < that.dd_promocode.length; i++) {
                                    if (that.dd_promocode[i].id == that.obj_ab.PI) {
                                        bool_isExists = true;
                                        break;
                                    }
                                }

                                if (!bool_isExists) {
                                    that.obj_ab.PI = null;
                                }
                            }
                        }
                        else {
                            that.dd_promocode = [];
                            that.obj_ab.PI = null;
                        }
                    });

                that.brand = that.renderAgentGroup(value);
                if (that.obj_ab['I'] == 0) {
                    var p = that.renderPosition(that.obj_ab.P);
                    that.obj_ab.ALT = that.brand + " Banner " + p;
                }
                //    }
            },
            getBannerPosition() {
                //this.dd_po = consBannerPosition;
                this.dd_po = [{ id: '1', label: this.getLanguage['BN']['P'] + " 1" }, { id: '2', label: this.getLanguage['BN']['P'] + " 2" },
                { id: '3', label: this.getLanguage['BN']['P'] + " 3" }, { id: '4', label: this.getLanguage['BN']['P'] + " 4" },
                { id: '5', label: this.getLanguage['BN']['P'] + " 5" }, { id: '6', label: this.getLanguage['BN']['P'] + " 6" },
                { id: '7', label: this.getLanguage['BN']['P'] + " 7" }, { id: '8', label: this.getLanguage['BN']['P'] + " 8" },
                { id: '9', label: this.getLanguage['BN']['P'] + " 9" }, { id: '10', label: this.getLanguage['BN']['P'] + " 10" },
                { id: '11', label: this.getLanguage['BN']['P'] + " 11" }, { id: '12', label: this.getLanguage['BN']['P'] + " 12" },
                { id: '13', label: this.getLanguage['BN']['P'] + " 13" }, { id: '14', label: this.getLanguage['BN']['P'] + " 14" },
                { id: '15', label: this.getLanguage['BN']['P'] + " 15" }, { id: '16', label: this.getLanguage['BN']['P'] + " 16" },
                { id: '17', label: this.getLanguage['BN']['P'] + " 17" }, { id: '18', label: this.getLanguage['BN']['P'] + " 18" },
                { id: '19', label: this.getLanguage['BN']['P'] + " 19" }, { id: '20', label: this.getLanguage['BN']['P'] + " 20" },
                { id: '21', label: this.getLanguage['BN']['P'] + " 21" }, { id: '22', label: this.getLanguage['BN']['P'] + " 22" },
                { id: '23', label: this.getLanguage['BN']['P'] + " 23" }, { id: '24', label: this.getLanguage['BN']['P'] + " 24" },
                { id: '25', label: this.getLanguage['BN']['P'] + " 25" }, { id: '26', label: this.getLanguage['BN']['GFP'] + " 1" },
                { id: '27', label: this.getLanguage['BN']['GFP'] + " 2" }, { id: '28', label: this.getLanguage['BN']['GFP'] + " 3" },
                { id: '29', label: this.getLanguage['BN']['GFP'] + " 4" }, { id: '30', label: this.getLanguage['BN']['GFP'] + " 5" }];
            },
            getBannerType() {
                //this.dd_to = this.appendSelectAllOption(consBannerType);
                this.dd_to = this.appendSelectAllOption([{ id: '1', label: this.getLanguage['ACO']['DT'] }, { id: '2', label: this.getLanguage['ACO']['MB'] }]);
            },
            getBannerStatus() {
                this.BannerStatus = [{ id: '1', label: this.getLanguage['GL']['DISB'] }, { id: '2', label: this.getLanguage['GL']['ENB'] }];
            },
            getLangauge() {
                var that = this;
                this.getDataApi(`/api/dd/lang/0`, function (d, s) {
                    if (s) {
                        //that.dd_lang = that.appendSelectAllOption(d.dropdownlist);
                        that.dd_langfs = that.appendSelectAllOption(d.dropdownlist);
                    }
                });
            },
            onFileSelected(event) {
                this.obj_ab['IU'] = null;
                this.selectedFile = this.validateFile(event);
                this.newImg = true;
            },
            handleImageAdded() { },
            closeAdd() {
                this.selectedFile = null;
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            closeAdd1() {
                this.previewUrl = null;
                this.bool_fullPreview = !this.bool_fullPreview;
            },
            setSortTable(SV) {
                //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort; //change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getBannerList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF
                    ? this.bool_isSort
                        ? "sort-descending"
                        : "sort-ascending"
                    : "list"
                    }`; //here change the sort logo
            },
            addBanner() {
                this.obj_ab = {
                    I: 0,
                    RS: true,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    DN: null,
                    MT: null,
                    DI: null,
                    DevType: null,
                    DT: null,
                    GPRVD: null,
                    P: null,
                    IU: "",
                    STS: 0,
                    BT: null,
                    ETS: 0,
                    AGI: 0,
                    L: null,
                    PGTS: null,
                    AGIT: null,
                    HS: false,
                    bannerImage: null,
                    Lang: null,
                    RURL: null,
                    IUT: false,
                    PGT: null,
                    PT: null,
                    ALT: null
                };
                this.arry_type = [];
                this.dd_do = [];
                this.dd_lang = [];
                this.bool_isAMV = true;
                this.bool_CV = false;
                this.newImg = false;
                this.excludeAGI = [];
                this.dateTS.startDate = this.getTodayDate();
                this.dateTS.endDate = this.getTodayEndDate();

                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.obj_ab.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_ab.AGIT);
                    }
                }
                //if (this.obj_ab.AT == 0) {
                //    this.rurlType();
                //}
            },
            returnRS() {
                if (this.obj_ab["RS"] == true) {
                    return 2;
                } else {
                    return 1;
                }
            },
            saveBanner() {

                this.bool_CV = true;
                //clear un-used data
                var rurlTab = this.getRURLTabIndex();

                if (this.obj_ab.AT == 0) {
                    this.obj_ab['DI'] = 0;

                    if (this.excludeAGI.length > 0) {
                        //for (var i = 0; i < this.excludeAGI.length; i++) {
                        //    this.excludeAGI[i] = this.excludeAGI[i].split("-")[1];
                        //}
                        this.obj_ab['SBEAGI'] = this.excludeAGI.join(',');
                    } else {
                        this.obj_ab['SBEAGI'] = null;
                    }
                }
                for (var d of this.dd_do) {
                    if (d.id == this.obj_ab["DI"]) {
                        this.obj_ab["DN"] = d.label;
                    }
                }

                if (rurlTab == 1) { // internal pages
                    //this.RURL = null;
                    this.obj_ab.RURL = this.generateURL();
                    if (this.obj_ab.RURL == "") { // if page type is selected without page title, prompt error and exit save function
                        this.bool_fullLoading = false;
                        this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.1031")));
                        //this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.4002"))
                        return;
                    }
                }

                //if (this.obj_ab.AT != 0 && this.obj_ab.GPRVD !=null) {
                //    this.bool_fullLoading = false;
                //    this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.1032")));
                //    //this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.4002"))
                //    return;
                //}

                if (rurlTab == 2) { //direct url
                    //clear dropdown
                    this.obj_ab.PT = null;
                    this.obj_ab.PGT = null;
                    this.obj_ab.GPRVD = null;
                }
                //get image url type
                var iurlTab = this.getIURLTabIndex();
                if (iurlTab != 1) { // external img url
                    if (this.obj_ab.IU != null && this.obj_ab.IU != "") {
                        //if img url is not empty
                        this.obj_ab.IUT = true;
                        this.newImg = true;
                    }
                }
                //get rs
                this.obj_ab.RS = this.returnRS();
                //validate data required
                this.$v.obj_ab.$touch();
                if (!this.$v.obj_ab.$error) {

                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;

                    if (this.obj_ab["HS"]) {
                        this.obj_ab["STS"] = this.parseDateToJsonString(this.dateTS.startDate);
                        this.obj_ab["ETS"] = this.parseDateToJsonString(this.dateTS.endDate);
                    }
                    else {
                        this.obj_ab["STS"] = this.parseDateToJsonString(this.getMinimumDate());
                        this.obj_ab["ETS"] = this.parseDateToJsonString(this.getMaximumDate());
                    }

                    if (this.obj_ab.AGIT != null && this.obj_ab.AGIT.length > 0) {
                        var agi = this.obj_ab.AGIT.split("-");
                        this.obj_ab.AGI = agi[1];
                    }

                    var temp_dt = "";
                    for (var i = 0; i < this.obj_ab["DevType"].length; i++) {
                        if (i != 0) {
                            temp_dt += ",";
                        }
                        temp_dt += this.obj_ab.DevType[i];
                    }
                    this.obj_ab["DT"] = temp_dt;

                    var temp_lang = "";
                    for (var i = 0; i < this.obj_ab["Lang"].length; i++) {
                        if (i != 0) {
                            temp_lang += ",";
                        }
                        temp_lang += this.obj_ab.Lang[i];
                    }
                    this.obj_ab["L"] = temp_lang;


                    var that = this;
                    if (this.newImg == true) {
                        //if new image is selected
                        that.obj_ab["bannerImage"] = that.selectedFile;
                        this.postDataApiWithAttach(`/api/bn/s`, this.obj_ab, function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.selectedFile = null;
                                that.getBannerList();
                            }
                        });
                    } else if (this.newImg == false && this.obj_ab["I"] > 0) {
                        that.obj_ab["bannerImage"] = null;
                        //if user edit, but want to retain image
                        this.postDataApiWithAttach(`/api/bn/s`, this.obj_ab, function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.selectedFile = null;
                                that.getBannerList();
                            }
                        });
                    } else {
                        that.bool_fullLoading = false;
                        that.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.4002")));
                    }
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_ab"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_ab[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["BN"][langKey]);
                    }
                }

            },
            ProviderChange(value) {
                //if (this.obj_ab['I'] == 0) {
                if (this.dd_gp != null) {
                    for (var prvd of this.dd_gp) {
                        if (prvd.id == value) {
                            return prvd.extra;
                        }
                    }
                }
                //}
            },
            getBannerList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(
                    this.int_Page,
                    this.int_RC,
                    this.str_tableSortBy,
                    this.bool_isSort
                );

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                var split = this.str_FV[i].FV[x].split("-");

                                if (split.length == 2) {
                                    temp_ += split[1];
                                }
                                else {
                                    temp_ += split[0];
                                }
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'STS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "" && this.str_FV[i].FV.endDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);

                                var full = cts_from + "," + cts_to;
                                path += ("f[STS_drsft]=" + full + "&f[ETS_dreft]=" + full);
                            }
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                this.getDataApi(`/api/bn/l?${path}`, function (d, s) {
                    if (s) {
                        that.bool_fullLoading = false;
                        that.setBannerList(d.D);
                        that.resizeTableHead();
                    }
                });
            },
            setBannerList(data) {
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_Total = data.TotalItems;
                this.arry_bl = data.Items;
            },
            setBanner(data) {
                //set banner status=
                this.obj_ab = Object.assign(this.obj_ab, data);
                var arry_splitLang = this.obj_ab["L"].split(",");
                this.obj_ab["Lang"] = arry_splitLang;
                var arry_splitDT = this.obj_ab["DT"].split(",");
                this.obj_ab["DevType"] = arry_splitDT;

                if (data.RS == 2) {
                    this.obj_ab.RS = true;
                }
                else {
                    this.obj_ab.RS = false;
                }



                if (this.obj_ab.AGI != 18) {
                    this.obj_ab.AGIT = "3-" + this.obj_ab.AGI;
                    this.AgentGroupChange(this.obj_ab.AGIT);
                }
                else if (this.obj_ab.AGI == 18) {
                    this.obj_ab.AGIT = "0-" + this.obj_ab.AGI;
                    this.obj_ab.AT = 0;
                    this.AgentGroupChange(this.obj_ab.AT);

                    if (this.obj_ab['SBEAGI']) {
                        this.excludeAGI = this.obj_ab['SBEAGI'].split(",");
                        //this.excludeAGI = this.excludeAGI.map(function (i) {
                        //    return "3-" + i;
                        //});
                    }
                }


                if (this.obj_ab["HS"]) {
                    this.dateTS.startDate = this.obj_ab.STS;
                    this.dateTS.endDate = this.obj_ab.ETS;
                }
                else {
                    this.dateTS.startDate = this.getTodayDate();
                    this.dateTS.endDate = this.getTodayEndDate();
                }
                this.DomainChange(data.DI);
                this.positionChange(data.P)
                this.bool_isAMV = true;

            },

            editBanner(id) {
                this.bool_fullLoading = true;
                this.newImg = false;
                this.excludeAGI = [];
                var that = this;
                this.getDataApi(`/api/bn/g/${id}`, function (d, s) {
                    that.bool_fullLoading = false;
                    if (s) {
                        that.setBanner(d.D);
                    }
                });
            },
            removeBanner(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            di: d.DI,
                            uts: d.UTS
                        };

                        this.postDataApi(`/api/bn/d`, dt, function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.getBannerList();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                        });
                    }
                });
            },
            renderStatus(index) {
                return this.BannerStatus[index - 1].label;
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            DeviceTypeDisplay(value) {
                if (this.dd_to[0].children[parseInt(value) - 1] != undefined) {
                    return this.dd_to[0].children[parseInt(value) - 1].label;
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getBannerList();
            },
            generatePageUrl(url) {
                if (url) {
                    url = url.trim().toLowerCase();
                    url = url.replace(/ /gi, "-");
                    url = url.replace(/%/gi, "-");
                    url = url.replace(/[^a-zA-Z0-9-_]/g, '');
                }

                return url;
            },
            generateGP(url) {
                if (url) {
                    url = url.trim().toLowerCase();
                    url = url.replace(/ /gi, "-");
                    url = url.replace(/_/gi, "-");
                    //url = url.replace(/[^a-zA-Z0-9-_]/g, '');
                }

                return url;
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getBannerList();
                }
            },
            clearDateRangeFilter() {
                this.str_FV[3].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
              setPreview(value) {
       this.previewUrl = value;
       this.bool_fullPreview = true;
   },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);

                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const allHeaderRows = this.$el.querySelectorAll('#tHead .custom-table thead tr');

                if (!allHeaderRows.length) return; // Early return if no header rows

                tables.forEach((table) => {
                    let nestedIndex = 0;

                    // Collect body cells from the first row
                    const bodyCells = Array.from(table.querySelectorAll('tbody tr:first-child td'));
                    if (!bodyCells.length) return; // Early return if no body cells

                    // Reset all widths before applying new ones
                    const bodyCellElements = table.querySelectorAll('tbody tr td');
                    [...allHeaderRows[0].querySelectorAll('th'), ...bodyCellElements].forEach(cell => cell.style.width = '');

                    // Apply widths to header and body cells
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        const isNested = [10, 11].includes(index);
                        const headerRow = isNested ? 2 : 1;
                        const headerCells = this.$el.querySelectorAll(`#tHead .custom-table thead tr:nth-child(${headerRow}) th`);

                        let headerCell = headerCells[isNested ? nestedIndex : index];
                        // Update header cell styles
                        if (headerCell) {
                            headerCell.style.width = width;
                        }

                        // Update body cell styles for the corresponding column
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach((td) => {
                            td.style.width = width;
                        });

                        // Increment nestedIndex for nested columns
                        if (isNested) nestedIndex++;
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            renderAgentGroup(int_agentGroup) {
                var AgentGroup = "";
                var that = this;
                for (var i = 0; i < that.dd_agentgroup.length; i++) {
                    if (that.dd_agentgroup2[i].children == null) {
                        AgentGroup = that.dd_agentgroup2[0].label.split("(")[0];
                        that.brand = AgentGroup;
                        return AgentGroup;
                    }
                    for (var j = 0; j < that.dd_agentgroup[i].children.length; j++) {
                        if (that.dd_agentgroup[i].children[j].children != null) {
                            for (var k = 0; k < that.dd_agentgroup[i].children[j].children.length; k++) {
                                if (that.dd_agentgroup[i].children[j].children[k].children != null) {
                                    for (var l = 0; l < that.dd_agentgroup[i].children[j].children[k].children.length; l++) {
                                        if (that.dd_agentgroup[i].children[j].children[k].children[l].id == int_agentGroup) {
                                            AgentGroup = that.dd_agentgroup[i].children[j].children[k].children[l].label.split("(")[0];
                                            that.brand = AgentGroup;
                                            return AgentGroup;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return AgentGroup;
            },
            renderPosition(value) {
                var Position = "";
                var that = this;
                for (var i = 0; i < that.dd_po.length; i++) {
                    if (that.dd_po[i].id == value) {
                        Position = that.dd_po[i].label;
                        return Position;
                    }
                }
                return Position;
            },
        }
    };
</script>

<style>
    .a {
        color: blue !important;
        cursor: pointer;
    }

    .tab-content .tab-pane {
        padding: 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/ContentManagementSystem/Banner.vue